// import { useState } from "react";
// import "./AuthStyle.css";
// import { useLogin } from "../hooks/useLogin";
// import logo from "../assets/images/login-logo.png";
// import { Link, useNavigate } from "react-router-dom";
// const LoginComponent = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const { login, error, isLoading } = useLogin();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const jobId = localStorage.getItem("pendingJobApplication");
//     const jobTitle = localStorage.getItem("pendingJobTitle");

//     const loginSuccess = await login(email, password); // Now login() returns true or false

//     if (loginSuccess) {
//       // ✅ Only redirect if login was successful
//       if (jobId && jobTitle) {
//         localStorage.removeItem("pendingJobApplication");
//         localStorage.removeItem("pendingJobTitle");

//         navigate(
//           `/api/jobs/job-details/${jobId}/${encodeURIComponent(jobTitle)}`
//         );
//       } else {
//         navigate("/api/dashboard"); // Default redirection
//       }
//     }
//   };

//   return (
//     <section className="login-page">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-6">
//             <div
//               className="d-flex justify-content-center align-items-center
//       vh-100 overflow-hidden"
//             >
//               <div
//                 className="card p-4 shadow-lg p-3 mb-5 bg-white rounded"
//                 style={{ width: "23rem" }}
//               >
//                 <div className="card-body">
//                   {error && !isLoading && (
//                     <p className="text-dangerx alert alert-danger text-center borderxx border-danger p-2">
//                       {error}
//                     </p>
//                   )}
//                   <h5 className="card-title text-center">
//                     <img
//                       className="img-fluid logo-image"
//                       src={logo}
//                       alt="Logo"
//                     />
//                     <hr />
//                     <b className="h2 opacity-50">Login</b> <br /> <br /> <br />
//                   </h5>
//                   <form onSubmit={handleSubmit}>
//                     <div className="mb-3">
//                       <label htmlFor="email" className="form-label">
//                         Email address
//                       </label>
//                       <input
//                         type="email"
//                         className="form-control form-control-lg"
//                         placeholder="Enter email"
//                         id="email"
//                         aria-describedby="emailHelp"
//                         required
//                         onChange={(e) => setEmail(e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-3">
//                       <label htmlFor="password" className="form-label">
//                         Password
//                       </label>
//                       <input
//                         type="password"
//                         className="form-control form-control-lg"
//                         placeholder="Enter password"
//                         id="password"
//                         aria-describedby="passwordHelp"
//                         required
//                         onChange={(e) => setPassword(e.target.value)}
//                       />
//                     </div>
//                     {/* grid gap-2 mt-3 */}
//                     <div className="d-grid gap-2 mt-3">
//                       <button
//                         type="submit"
//                         className="btn btn-outline-primary fw-bold btn-lg btn-block"
//                         disabled={isLoading || !email || !password}
//                       >
//                         {!error && isLoading ? (
//                           <>
//                             <div
//                               className="spinner-border spinner-border-sm me-3"
//                               role="status"
//                               aria-hidden="true"
//                               style={{ width: "1.5rem", height: "1.5rem" }}
//                             ></div>
//                             <small
//                               className="text-muted"
//                               style={{ fontSize: "12px" }}
//                             >
//                               Please wait...
//                             </small>
//                           </>
//                         ) : (
//                           <div>LOGIN</div>
//                         )}
//                       </button>
//                     </div>{" "}
//                     <Link to="/api/users/forgot-password">
//                       Forgot password?
//                     </Link>
//                   </form>
//                   <br /> <br />
//                   <p className="text-muted mt-2">
//                     Don't have an account?{" "}
//                     <Link className="text-primary" to="/api/users/register">
//                       Register
//                     </Link>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default LoginComponent;

// import { useState } from "react";
// import { useLogin } from "../hooks/useLogin";
// import { Link, useNavigate } from "react-router-dom";
// import logo from "../assets/images/login-logo.png";
// import "./AuthStyle.css";

// const LoginComponent = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const { login, error, isLoading } = useLogin();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const jobId = localStorage.getItem("pendingJobApplication");
//     const jobTitle = localStorage.getItem("pendingJobTitle");

//     const loginSuccess = await login(email, password);

//     if (loginSuccess) {
//       if (jobId && jobTitle) {
//         localStorage.removeItem("pendingJobApplication");
//         localStorage.removeItem("pendingJobTitle");
//         navigate(
//           `/api/jobs/job-details/${jobId}/${encodeURIComponent(jobTitle)}`
//         );
//       } else {
//         navigate("/api/dashboard");
//       }
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-wrapper">
//         <div className="login-left-panel">
//           <div className="login-left-content">
//             <h1 className="welcome-text">Welcome Back</h1>
//             <p className="welcome-subtext">
//               Please login to access your account
//             </p>
//             <div className="login-features">
//               <div className="feature-item">
//                 <i className="fa fa-check-circle feature-icon"></i>
//                 <span>Access to all courses</span>
//               </div>
//               <div className="feature-item">
//                 <i className="fa fa-check-circle feature-icon"></i>
//                 <span>Personal dashboard</span>
//               </div>
//               <div className="feature-item">
//                 <i className="fa fa-check-circle feature-icon"></i>
//                 <span>Job application tracking</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="login-right-panel">
//           <div className="login-card">
//             <div className="logo-container">
//               <img src={logo} alt="Logo" className="login-logo" />
//             </div>

//             <h2 className="login-title">Sign In</h2>
//             <p className="login-subtitle">Enter your credentials to continue</p>

//             {error && !isLoading && (
//               <div className="alert alert-danger login-error">
//                 <i className="fa fa-exclamation-circle"></i> {error}
//               </div>
//             )}

//             <form onSubmit={handleSubmit} className="login-form">
//               <div className="form-group">
//                 <label htmlFor="email" className="form-label">
//                   <i className="fa fa-envelope input-icon"></i> Email Address
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type="email"
//                     className="form-control"
//                     placeholder="your@email.com"
//                     id="email"
//                     required
//                     onChange={(e) => setEmail(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="password" className="form-label">
//                   <i className="fa fa-lock input-icon"></i> Password
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type="password"
//                     className="form-control"
//                     placeholder="••••••••"
//                     id="password"
//                     required
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="form-options">
//                 <div className="form-check">
//                   <input
//                     type="checkbox"
//                     className="form-check-input"
//                     id="rememberMe"
//                   />
//                   <label className="form-check-label" htmlFor="rememberMe">
//                     Remember me
//                   </label>
//                 </div>
//                 <Link
//                   to="/api/users/forgot-password"
//                   className="forgot-password"
//                 >
//                   Forgot password?
//                 </Link>
//               </div>

//               <button
//                 type="submit"
//                 className="btn btn-primary login-btn"
//                 disabled={isLoading || !email || !password}
//               >
//                 {isLoading ? (
//                   <>
//                     <i className="fa fa-spinner fa-spin"></i> Authenticating...
//                   </>
//                 ) : (
//                   <>
//                     <i className="fa fa-sign-in"></i> Login
//                   </>
//                 )}
//               </button>

//               <div className="login-footer">
//                 Don't have an account?{" "}
//                 <Link to="/api/users/register" className="register-link">
//                   Create account
//                 </Link>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginComponent;

import { useState } from "react";
import { useLogin } from "../hooks/useLogin";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/login-logo.png";

const LoginComponent = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, error, isLoading } = useLogin();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const jobId = localStorage.getItem("pendingJobApplication");
    const jobTitle = localStorage.getItem("pendingJobTitle");

    const loginSuccess = await login(email, password);

    if (loginSuccess) {
      if (jobId && jobTitle) {
        localStorage.removeItem("pendingJobApplication");
        localStorage.removeItem("pendingJobTitle");
        navigate(
          `/api/jobs/job-details/${jobId}/${encodeURIComponent(jobTitle)}`
        );
      } else {
        navigate("/api/dashboard");
      }
    }
  };

  return (
    <div className="container vh-100 bg-light">
      <div className="row h-100">
        {/* Left Panel - Welcome Section */}
        <div className="col-lg-6 d-none d-lg-flex bg-primary text-white p-5">
          <div className="d-flex flex-column justify-content-center">
            <h1 className="display-4 fw-bold mb-4">Welcome Back</h1>
            <p className="fs-5 mb-5">Please login to access your account</p>

            <div className="d-flex flex-column gap-3">
              <div className="d-flex align-items-center gap-3">
                <i className="fa fa-check-circle fs-4"></i>
                <span className="fs-5">Access to all courses</span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <i className="fa fa-check-circle fs-4"></i>
                <span className="fs-5">Personal dashboard</span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <i className="fa fa-check-circle fs-4"></i>
                <span className="fs-5">Job application tracking</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="col-lg-6 d-flex align-items-center justify-content-center p-4">
          <div className="w-100" style={{ maxWidth: "400px" }}>
            <div className="text-center mb-4">
              <img
                src={logo}
                alt="Logo"
                className="img-fluid mb-3"
                style={{ height: "60px" }}
              />
              <h2 className="fw-bold mb-2">Sign In</h2>
              <p className="text-muted">Enter your credentials to continue</p>
            </div>

            {error && !isLoading && (
              <div className="alert alert-danger d-flex align-items-center mb-4">
                <i className="fa fa-exclamation-circle me-2"></i>
                <div>{error}</div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="mb-3">
              {/* Email Input */}
              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-medium">
                  <i className="fa fa-envelope me-2 text-primary"></i>Email
                  Address
                </label>
                <input
                  type="email"
                  className="form-control form-control-lg"
                  placeholder="your@email.com"
                  id="email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Password Input */}
              <div className="mb-3">
                <label htmlFor="password" className="form-label fw-medium">
                  <i className="fa fa-lock me-2 text-primary"></i>Password
                </label>
                <input
                  type="password"
                  className="form-control form-control-lg"
                  placeholder="••••••••"
                  id="password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rememberMe"
                  />
                  <label className="form-check-label" htmlFor="rememberMe">
                    Remember me
                  </label>
                </div>
                <Link
                  to="/api/users/forgot-password"
                  className="text-primary text-decoration-none"
                >
                  Forgot password?
                </Link>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-primary btn-lg w-100 mb-3"
                disabled={isLoading || !email || !password}
              >
                {isLoading ? (
                  <>
                    <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                    Authenticating...
                  </>
                ) : (
                  <>
                    <i className="fa fa-sign-in-alt me-2"></i> Login
                  </>
                )}
              </button>

              {/* Sign Up Link */}
              <div className="text-center text-muted mt-4">
                Don't have an account?{" "}
                <Link
                  to="/api/users/register"
                  className="text-primary fw-medium text-decoration-none"
                >
                  Create account
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
